
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing-biologics",
      function () {
        return require("private-next-pages/pricing-biologics.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing-biologics"])
      });
    }
  